import { print } from 'graphql'
import { Address } from 'shopify-types'

import { GlobalRequestOptions } from '@/shopify/types'

import { storefrontClient } from '../..'
import { UpdateAddressDocument, type UpdateAddressMutation } from '../../__generated/storefront'
import { mapGQLAddressToAddress } from './graphql'

export const updateAddress =
  (options: GlobalRequestOptions) => async (token: string, address: Address) => {
    const response = await storefrontClient.request<UpdateAddressMutation>(
      print(UpdateAddressDocument),
      {
        variables: {
          id: address.id,
          address: { ...address, id: undefined },
          customerAccessToken: token,
          language: options.language,
        },
      },
    )

    const payload = response.data?.customerAddressUpdate

    if (!payload?.customerAddress) {
      throw new Error('Failed to update address')
    }

    return mapGQLAddressToAddress(payload.customerAddress)
  }
